import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from './Home';
import ViewIssues from "./ViewIssues";
import ViewIssue from './ViewIssue';

export default function Navigation() {
    return (
        <Switch>
            <Route path='/view/:id'>
                <ViewIssue />
            </Route>
            <Route path='/all'>
                <ViewIssues />
            </Route>
            <Route path='/'>
                <Home />
            </Route>
        </Switch>
    )
}
